import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_AD_UNIT } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteAdUnit, UseDeleteAdUnitProps } from './types'

export const useDeleteAdUnit = ({ path }: UseDeleteAdUnitProps): UseDeleteAdUnit => {
  const { t } = useTranslation('features/adUnit')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_AD_UNIT,
    onCompleted: async data => {
      const { deleteAdUnit } = data

      if (deleteAdUnit) {
        const { errors } = deleteAdUnit

        if (errors && errors.length > 0) {
          enqueueSnackbar(
            t('delete.action.error', { adUnitName: path, interpolation: { escapeValue: false } }),
            { variant: 'error' },
          )
        }
      } else {
        enqueueSnackbar(
          t('delete.action.success', { adUnitName: path, interpolation: { escapeValue: false } }),
          { variant: 'success' },
        )
      }
    },
    queriesToInvalidate: ['getAdUnitsForTable'],
  })

  const deleteAdUnit: UseDeleteAdUnit['deleteAdUnit'] = id => void mutateAsync({ input: { id } })

  return { deleteAdUnit, loading }
}
